import freeSpins10 from 'images/freespins/freespins-10.png';
import freeSpins20 from 'images/freespins/freespins-20.png';
import freeSpins30 from 'images/freespins/freespins-30.png';
import freeSpins40 from 'images/freespins/freespins-40.png';
import freeSpins50 from 'images/freespins/freespins-50.png';
import freeSpins75 from 'images/freespins/freespins-75.png';
import freeSpins100 from 'images/freespins/freespins-100.png';

const freeSpinsQuantityImages: Record<number, string> = {
    10: freeSpins10,
    100: freeSpins100,
    20: freeSpins20,
    30: freeSpins30,
    40: freeSpins40,
    50: freeSpins50,
    75: freeSpins75
};

export const getFreeSpinsQuantityImage = (quantity: number): string | null => freeSpinsQuantityImages[quantity] ?? null;
